import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Overview from '../pages/Overview/Overview';
import FleetRegistry from '../pages/FleetRegistry/FleetRegistry';
import Utilisation from '../pages/Utilisation/Utilisation';
import Flights from '../pages/Flights/Flights';
import MRO from '../pages/MRO/MRO';
import LifecycleRisk from '../pages/LifecycleRisk/LifecycleRisk';
import OperatorHistory from '../pages/OperatorHistory/OperatorHistory';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/"            element={<Overview />} />
      <Route path="/fleet"       element={<FleetRegistry />} />
      <Route path="/utilisation" element={<Utilisation />} />
      <Route path="/flights"     element={<Flights />} />
      <Route path="/mro"         element={<MRO />} />
      <Route path="/risk"        element={<LifecycleRisk />} />
      <Route path="/history"     element={<OperatorHistory />} />
    </Routes>
  );
}
